import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormSelect from "Common/Custom/FormSelect";

// Uses `fields` prop from parent — does not re-import JSON directly
// roomTypeOptions fetched in parent (EditComplementary) — not inside this form
const EditComplementaryForm = ({
    fields = [],
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
    roomTypeOptions = [],
    title = "Edit Complementary",
}) => {
    return (
        <PageBody
            headerchildren={<HeadingOne>{title}</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                if (field.type === "select") {
                    const options = roomTypeOptions.map((opt) => ({
                        value: opt.room_id,
                        label: opt.room_type,
                    }));
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={String(values[field.name] ?? "")}
                            handleChange={handleChange}
                            options={options}
                            error={errors[field.name]}
                        />
                    );
                }
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Update Complementary"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default EditComplementaryForm;
